const colors = {
  white: '#ffffff',
  black: '#000000',
  brandThemeDark900: '#0c1e2c',
  brandThemeDark700: '#275b86',
  brandThemeDark500: '#3f88c5',
  actionPrimary300: '#4ba1e9',
  brandThemeLight500: '#d7d6cb',
  brandThemeLight300: '#e2ded1',
  brandThemeLight100: '#f1efe9',
  primaryFont: '#0c1e2c',
  accentFont: '#4ba1e9',
  error300: '#ff4949',

  // warning colors: orange and yellow
  warning500: '#ff8500',
  warning300: '#ffdd00',

  // darkest/worse (1) to lightest/best (3)
  success1: '#7ac121',
  success2: '#7ad521',
  success3: '#7aeb21'
};

const breakpoints = {
  xxs: '375px',
  xs: '520px',
  sm: '768px',
  md: '1024px',
  lg: '1280px',
  xl: '1760px'
};

export const TrueNorthLight = {
  dark: true,
  name: 'True North Light',
  colors,
  breakpoints,
  containerMaxWidth: '1080px'
};
